let key = `6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI`;

if (process.env.REACT_APP_STAGING_ENV) {
  if (process.env.REACT_APP_STAGING_ENV === 'production' || process.env.REACT_APP_STAGING_ENV === 'preprod') {
    key = `6LfvTr8UAAAAAJ-igpf1TITIYawtQaiCiz0up3Pl`;
  }
}

export const getCAPTCHAKey = () => { return key; }